import { Box, Typography, Avatar } from '@mui/material';
import LabelIcon from '@mui/icons-material/Label';
import moment from 'moment';
import '@Partials/_ComStyles.scss';
import '@Partials/_SimpleStyles.scss';
import '@Partials/_OverrideStyles.scss';
import './LabelCardRow.scss';

export default function LabelCardRow(props) {
  const className = 'labelCardRow';
  const isSelected = props.labelCard?.id === props.selectedLabelCard?.id;

  const formatDate = (ts) => (ts ? moment(ts).format('MMM DD, YYYY') : '');

  const getLabelColor = (name) => {
    if (!name) return '#1976d2';
    const hash = name.split('').reduce((acc, char) => char.charCodeAt(0) + acc, 0);
    const colors = ['#1976d2', '#2e7d32', '#8e24aa', '#d32f2f', '#ef6c00', '#0288d1'];
    return colors[hash % colors.length];
  };

  return (
    <div
      className={`${className} ${isSelected ? `${className}--selected` : ''}`}
      onClick={() => props.setSelectedLabelCard(props.labelCard)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && props.setSelectedLabelCard(props.labelCard)}
    >
      <Box className={`${className}__container`}>
        {/* Label Icon/Avatar */}
        <Avatar
          className={`${className}__avatar`}
          style={{ background: getLabelColor(props.labelCard?.name) }}
        >
          <LabelIcon />
        </Avatar>

        {/* Content */}
        <Box className={`${className}__content`}>
          <Box className={`${className}__header`}>
            <Typography variant="subtitle1" className={`${className}__name`}>
              {props.labelCard?.name || 'Unnamed Label'}
            </Typography>
            {!!props.labelCard?.createTimeStamp && (
              <Typography variant="caption" className={`${className}__date`}>
                {formatDate(props.labelCard.createTimeStamp)}
              </Typography>
            )}
          </Box>

          {props.labelCard?.description && (
            <Typography variant="caption" className={`${className}__description`}>
              {props.labelCard.description}
            </Typography>
          )}
        </Box>

        {/* Selection Indicator */}
        {isSelected && <div className={`${className}__indicator`} />}
      </Box>
    </div>
  );
}
